import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { FormHelperText } from "material-ui/Form";
import { Link } from "redux-little-router";

import TextField from "../../../../components/FormElements/TextField";

import { email, required, minLength8 } from "../../../../util/formValidations";

import RoundedButton from "../../../../components/RoundedButton";
import OverlayLoader from "../../../../components/OverlayLoader";
import "./index.css";

class SignupForm extends Component {
  render() {
    const { handleSubmit, submitting, error } = this.props;
    return (
      <form className="signup-form form" onSubmit={handleSubmit}>
        {submitting && <OverlayLoader />}
        <h1>Create new account</h1>
        <div className="grouped-field">
          <Field
            name="firstName"
            className="-horizontalpadding"
            component={TextField}
            label="First Name"
            validate={[required]}
          />
          <Field
            name="lastName"
            className="-horizontalpadding"
            component={TextField}
            label="Last Name"
            validate={[required]}
          />
        </div>
        <Field name="email" component={TextField} label="Email" validate={[required, email]} />
        <Field
          name="password"
          component={TextField}
          label="Password"
          validate={[required, minLength8]}
          type="password"
        />
        <div>
          <RoundedButton value="Create new account" className="-primary" type="submit" />
        </div>
        {!!error && <FormHelperText error>{error}</FormHelperText>}
        <hr className="divider" />
        <span className="signin-anchor">
          Already have an account?
          <Link href="/signin"> Sign in </Link>
        </span>
      </form>
    );
  }
}

export default reduxForm({ form: "signupForm" })(SignupForm);



// WEBPACK FOOTER //
// ./src/scenes/SignupPage/components/SignupForm/index.js